export const styleTextLink = { cursor: "pointer", color: "blue" };